// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  auth0: {
    domain: 'credipal-dev.us.auth0.com',
    clientId: 'J4pRUriDlO83imkZOrFkikznpf5mZt0h',
    redirectUri: window.location.origin,
  },
  apiUrl: 'https://credipal-dev-personas-api.azurewebsites.net/api/',
  apiMensajeUrl: 'https://credipal-dev-mensajes-api.azurewebsites.net/api/',
  //apiUrl: 'https://localhost:7271/api/',
};